import { CancelToken, isCancel } from 'axios'

export default {
  namespaced: true,
  state: {
    // The document bundles currently visible
    active: [],
    // Used to indicate when waiting on the server
    loading: false,
    // Token source used to abandon requests when navigating away
    source: null,
    // The search string being applied
    search: '',
    // What filters are currently applied
    filters: {},
    // The total records matching the filter according to the server (for pagination)
    total: 0,
    // The current page being viewed and its size
    page: 1,
    rowsPerPage: 25,
    // Sorting
    sort: {
      by: 'createdAt',
      descending: true
    }
  },
  getters: {
    find: state => id => state.active.find(bundle => bundle.id == id)
  },
  mutations: {
    setActive(
      state,
      {
        items = [],
        page = 1,
        per = 25,
        total = 0,
        search = null,
        sort = { by: 'created_at', descending: true },
        filters = {}
      }
    ) {
      state.search = search
      state.active = items
      state.sort = sort
      state.filters = filters
      state.page = page
      state.rowsPerPage = per
      state.total = total
      state.loading = false
    },
    set(state, bundle) {
      state.active = state.active.filter(o => o.id != bundle.id)
      state.active.push(bundle)
    },
    remove(state, id) {
      state.active = state.active.filter(o => o.id != id)
    }
  },
  actions: {
    abandon({ state }, reason) {
      if (state.source) {
        state.source.cancel(reason)
        state.source = null
        state.loading = false
      }
    },
    search(
      { commit, state },
      { search = '', page = 1, rowsPerPage = 25, sortBy = 'created_at', descending = true, filters = {} }
    ) {
      this.$authorize('list', 'DocumentBundle')

      // Cancel previous search actions
      if (state.source) {
        state.source.cancel()
      }
      state.source = CancelToken.source()

      const params = {
        search: search,
        page: page,
        per: rowsPerPage,
        sort: `${sortBy} ${descending ? 'DESC' : 'ASC'}`,
        ...filters
      }

      state.loading = true
      return Vue.$http.get('admin/document_bundles', { params, cancelToken: state.source.token }).then(
        response => commit('setActive', response.data),
        errors => {
          if (!isCancel(errors)) state.loading = false
        }
      )
    },
    // fetch({ commit }, id) {
    //   return Vue.$http
    //     .get(`admin/document_bundles/${id}`, { cancelToken: state.source.token })
    //     .then(response => commit('set', response.data))
    // },
    create({ commit, state }, bundle) {
      this.$authorize('create', 'DocumentBundle')

      if (state.source) state.source.cancel()
      state.source = CancelToken.source()
      return Vue.$http.post('admin/document_bundles', { bundle, cancelToken: state.source.token }).then(
        response => {
          commit(
            'snackbar',
            {
              text: 'Your document bundle has been requested. You will receive an email with a download link.',
              type: 'success'
            },
            { root: true }
          )
        },
        errors => {
          if (!isCancel(errors)) {
            state.loading = false
            commit(
              'snackbar',
              {
                text: 'There was a problem requesting the document bundle',
                type: 'error'
              },
              { root: true }
            )
          }
        }
      )
    }
  }
}
